import React, { useEffect } from "react";
import { UseFormReturn, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as RemoveSVG } from "go-core/images/svg/actions/remove.svg";
import FormNumberInput from "go-form/components/FormNumberInput";
import { ProductApi } from "../../../../../../../../services/Api/Organization/types";

interface Props {
	form: UseFormReturn<ProductApi>;
}

const ProductVolumesTableForm = ({ form }: Props) => {
	const {
		watch,
		control,
		register,
		formState: { errors },
	} = form;
	const { t } = useTranslation();
	const { fields, remove, append } = useFieldArray({
		control,
		name: "product_volumes",
		keyName: "key",
	});
	const watchedVolumes = watch("product_volumes");
	const volumesAsString = JSON.stringify(watchedVolumes);
	const { isMobile, isSmallBreakpoint } = useWindowSize();

	const checkIfAddNewVolume = () => {
		const prevVolume = watchedVolumes[watchedVolumes?.length - 1];
		return prevVolume?.volume || prevVolume?.label;
	};

	useEffect(() => {
		if (checkIfAddNewVolume()) {
			append(
				{
					volume: null,
					label: null,
				},
				{ shouldFocus: false }
			);
		}
	}, [volumesAsString]);

	const handleRemove = (index: number) => remove(index);

	return (
		<>
			<h5 className="mb-1">{t("modules.product.field.volumes.title")}</h5>
			<fieldset className={`form-group ${isSmallBreakpoint ? "table-responsive" : ""}`}>
				<table className="table table-form positions-table vertical-top">
					<thead>
						<tr>
							<th className="action" />
							<th style={{ minWidth: isMobile ? "150px" : "unset" }}>{t("common.word.volume")}</th>
							<th style={{ minWidth: isMobile ? "250px" : "unset" }}>{t("common.word.measure_type")}</th>
							<th className="action" />
						</tr>
					</thead>
					<tbody>
						{watchedVolumes?.map((item, index) => (
							<tr key={fields[index].key}>
								<td className="action" />
								<td>
									<FormNumberInput
										errors={errors}
										name={`product_volumes.${index}.volume`}
										control={control}
										suffix=""
										allowNegative={false}
									/>
								</td>
								<td>
									<FormInput
										name={`product_volumes.${index}.label`}
										errors={errors}
										register={register}
									/>
								</td>
								<td className="action">
									{!(index === 0 && index === watchedVolumes.length - 1) && (
										<RemoveSVG className="icon" onClick={() => handleRemove(index)} />
									)}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</fieldset>
		</>
	);
};

export default ProductVolumesTableForm;
